<template>
  <div></div>
</template>

<script>
import {getDeviceInfo, getLocale, selectLanguage} from '@/utils'
import { mapState } from 'vuex'

export default {
  name: 'SessionStart',
  data: function() {
    return {
      retries: 2
    }
  },
  computed: {
    ...mapState(['criticalError']),
    params: function() {
      let params = {device: getDeviceInfo(), locale: getLocale()}

      if ('step' in this.$route.params) {
        params.step = this.$route.params.step
      }

      [
        'tracking_source',
        'sid1',
        'sid2',
        'sid3',
        'ticket_id',
        'customer_id',
        'order_number',
        'language',
        'email',
        'phone',
        'product_id',
        'campaign_product_id',
        'variant_id',
        'offer_intent',
        'session_type'
      ].forEach(key => {
        if (key in this.$route.query) {
          params[key] = this.$route.query[key]
        }
      })

      return params
    }
  },
  methods: {
    start: function() {
      console.log('attempt ' + this.retries.toString())

      if (this.params['language']) {
        selectLanguage(this.params['language'].toString().toLowerCase())
      }

      this.$store.dispatch('start', this.params)
        .then(session => {
          console.log(session)
          if (session.customer) {
            this.$store.dispatch('get_cart')
          }
          this.$store.commit('toggle_loader_display', true)
          if (this.$route.query.is_chatbot_embed) {
            this.$router.replace({name: 'chatbot-embed'})
          } else if (session.can_enter_exit_lifeline) {
            history.replaceState(null, null, '/undo')
            this.$router.push({name: 'session'})
          } else {
            this.$router.replace({name: 'session'})
          }
        })
        .catch(err => {
          if (err.code && (err.code === 'ECONNABORTED') && (this.retries > 0)) { // timeout with retries
            this.retries--
            this.start()
          } else {
            console.log(err)
            this.$store.commit('auth_critical_error', err)
          }
        })
    }
  },
  created() {
    this.start()
  }
}
</script>

<style scoped>

</style>
